import { render, staticRenderFns } from "./NormalSearchNav520.vue?vue&type=template&id=f82ed912&scoped=true"
import script from "./NormalSearchNav520.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav520.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82ed912",
  null
  
)

export default component.exports